/* SL Product Template — interactions (gallery, wholesale steppers, tabs, announcement rotator) */
(function () {
  "use strict";

  var SYMBOLS = { GHS: "GH₵", USD: "$", EUR: "€", GBP: "£", NGN: "₦", CAD: "$", AUD: "$" };
  function money(cents, currency) {
    var sym = SYMBOLS[currency] || (currency + " ");
    return sym + " " + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  document.addEventListener("DOMContentLoaded", function () {
    /* ---------- Gallery thumbnails ---------- */
    document.querySelectorAll("[data-sl-gallery]").forEach(function (gal) {
      var main = gal.querySelector("[data-sl-main-img]");
      gal.querySelectorAll("[data-sl-thumb]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          gal.querySelectorAll("[data-sl-thumb]").forEach(function (b) { b.classList.remove("is-active"); });
          btn.classList.add("is-active");
          if (main && btn.dataset.full) {
            main.src = btn.dataset.full;
            main.srcset = btn.dataset.full;
          }
        });
      });
    });

    /* ---------- Wholesale per-variant steppers ---------- */
    var product = document.querySelector("[data-sl-product]");
    if (product) {
      var minPerSize = parseInt(product.dataset.minPerSize || "0", 10);
      var currency = product.dataset.currency || "USD";
      var rows = Array.prototype.slice.call(product.querySelectorAll("[data-variant-id]"));
      var countEl = product.querySelector("[data-summary-count]");
      var totalEl = product.querySelector("[data-summary-total]");
      var addBtn = product.querySelector("[data-add]");
      var buyBtn = product.querySelector("[data-buy]");
      var errEl = product.querySelector("[data-error]");

      function showError(msg) {
        if (!errEl) return;
        errEl.textContent = msg;
        errEl.hidden = !msg;
      }

      function updateSummary() {
        var items = 0, total = 0;
        rows.forEach(function (row) {
          var qty = parseInt(row.querySelector("[data-qty]").textContent, 10) || 0;
          items += qty;
          total += qty * parseInt(row.dataset.price, 10);
        });
        if (countEl) countEl.innerHTML = "<strong>" + items + "</strong> item" + (items === 1 ? "" : "s") + " selected";
        if (totalEl) totalEl.innerHTML = "<strong>" + money(total, currency) + "</strong>";
        if (addBtn) addBtn.disabled = items === 0;
        showError("");
      }

      rows.forEach(function (row) {
        var qtyEl = row.querySelector("[data-qty]");
        var minus = row.querySelector('[data-step="-1"]');
        var plus = row.querySelector('[data-step="1"]');
        var tracked = row.dataset.tracked === "true";
        var inv = parseInt(row.dataset.inventory || "0", 10);
        var max = tracked ? Math.max(inv, 0) : 999;
        var soldOut = row.dataset.available !== "true";

        function setQty(n) {
          n = Math.max(0, Math.min(max, n));
          qtyEl.textContent = n;
          minus.disabled = n <= 0;
          plus.disabled = n >= max;
          updateSummary();
        }
        if (soldOut) {
          minus.disabled = true; plus.disabled = true;
          return;
        }
        minus.addEventListener("click", function () { setQty(parseInt(qtyEl.textContent, 10) - 1); });
        plus.addEventListener("click", function () { setQty(parseInt(qtyEl.textContent, 10) + 1); });
        setQty(0);
      });

      function collectItems() {
        var items = [];
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          var qty = parseInt(row.querySelector("[data-qty]").textContent, 10) || 0;
          if (qty > 0) {
            if (minPerSize > 0 && qty < minPerSize) {
              showError("Minimum " + minPerSize + " per size — please raise the quantity for size " + row.dataset.variantTitle + ".");
              return null;
            }
            items.push({ id: parseInt(row.dataset.variantId, 10), quantity: qty });
          }
        }
        return items;
      }

      function addToCart(items, buyNow) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
          .then(function () { window.location.href = buyNow ? "/checkout" : "/cart"; })
          .catch(function () { showError("Something went wrong adding to cart. Please try again."); });
      }

      if (addBtn) addBtn.addEventListener("click", function () {
        var items = collectItems();
        if (items && items.length) addToCart(items, false);
      });
      if (buyBtn) buyBtn.addEventListener("click", function () {
        var items = collectItems();
        if (items && items.length) addToCart(items, true);
        else showError("Select a quantity for at least one size first.");
      });
      updateSummary();
    }

    /* ---------- Pill tabs ---------- */
    document.querySelectorAll("[data-sl-tabs]").forEach(function (tabs) {
      var btns = tabs.querySelectorAll("[data-tab-btn]");
      var panels = tabs.querySelectorAll("[data-tab-panel]");
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          btns.forEach(function (b) { b.classList.remove("is-active"); });
          panels.forEach(function (p) { p.classList.remove("is-active"); });
          btn.classList.add("is-active");
          var panel = tabs.querySelector('[data-tab-panel="' + btn.dataset.tabBtn + '"]');
          if (panel) panel.classList.add("is-active");
        });
      });
    });

    /* ---------- Announcement rotator ---------- */
    document.querySelectorAll("[data-sl-rotator]").forEach(function (rot) {
      var msgs = rot.querySelectorAll("[data-sl-msg]");
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.add("is-hidden");
        i = (i + 1) % msgs.length;
        msgs[i].classList.remove("is-hidden");
      }, 5000);
    });
  });
})();
